import { render } from "./ProductCollectionsComponent.vue?vue&type=template&id=4960d650"
import script from "./ProductCollectionsComponent.vue?vue&type=script&lang=js"
export * from "./ProductCollectionsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/ProductCollectionsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4960d650"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4960d650', __exports__)) {
    api.reload('4960d650', __exports__)
  }
  
  module.hot.accept("./ProductCollectionsComponent.vue?vue&type=template&id=4960d650", () => {
    api.rerender('4960d650', render)
  })

}


export default __exports__